import React, { Component } from "react";
import { BsChevronLeft, BsChevronRight, BsGlobe } from "react-icons/bs";
import Ink from "react-ink";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import DelayLink from "react-delay-link";

export class BackButtonWithName extends Component {
  static contextTypes = {
    router: () => null,
  };

  onHandleBack = () => {
    this.props.history.goBack();
  };

  changeLanguage = () => {
    if (localStorage.getItem("lang") == "en") {
      var lang = "ar";
    } else {
      var lang = "en";
    }

    Axios.post("https://freshloop.howincloud.com/public/api/get-translations", {
      lang: lang,
    }).then((response) => {
      if (response.data.lang) {
        const langs = response.data.data;
        localStorage.setItem("lang", lang);
        langs.forEach((item) => {
          localStorage.setItem(item.key, item.value);
        });
      }

      window.location.reload();
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="header-fixed ">
          <div
            className="d-flex flex-row  align-items-center"
            style={{
              backgroundColor: this.props.color ? this.props.color : "#fff",
            }}
          >
            <div className="mb-2 ">
              <div onClick={this.props.history.goBack}>
                <div
                  className="position-relative ms-3 me-3 mt-3 py-2"
                  style={{
                    backgroundColor: "#fff",
                    boxShadow: "rgb(0 0 0 / 15%) 0px 2px 20px",
                    borderRadius: "50%",
                    width: "52px",
                    height: "52px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {localStorage.getItem("lang") == "ar" ? (
                    <BsChevronRight size={25} />
                  ) : (
                    <BsChevronLeft size={25} />
                  )}
                  {/* <Ink style={{ color: '#aaaaaa' }} /> */}
                </div>
              </div>
            </div>
            <div className=" ms-3 mt-3 mb-2">
              <span
                className=" user-select-none"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                {this.props.title}
              </span>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(BackButtonWithName);
